import { render, staticRenderFns } from "./SignageLayout.vue?vue&type=template&id=e8545cc4"
import script from "./SignageLayout.vue?vue&type=script&lang=js"
export * from "./SignageLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports